import moment from "moment";
import styled from "styled-components";
import {UserIcon} from "ui/icons";
import {defaultThemeColors, fonts, themeColor} from "ui/theme";
import {ButtonPrimary} from "../Button/ButtonStyled";
import React from "react";
import {RescheduleCard} from "./components/RescheduleCard";
import {Avatar} from "ui/base/editAvatar/Avatar";
import {ClassDateCard} from "../dateCard/ClassDateCard";
import {Countdown} from "../countdown/Countdown";
import {timeLeftToAcceptOrDecline} from "utils";

require("moment-timezone");

export const DEFAULT_TIMEZONE = "America/New_York";
const RESCHEDULE_STATUS = {accepted: "accepted", rejected: "rejected"};

export const UpcomingClassCardInstructor = ({
                                                upcomingClass,
                                                onCancel,
                                                onProfile,
                                                acceptReschedule,
                                                rejectReschedule,
                                                sendMessage
                                            }) => {
    const isRescheduled = upcomingClass.booking_slot_status === "rescheduled";

    const class_type = upcomingClass?.class_type
        ? upcomingClass.class_type.toLowerCase()
        : "";


    const isOnline = upcomingClass?.online_type === "online"

    const badgeVariant = isOnline ? "black_fade_small" : class_type === "private" ? "primary_fade_small" : "destructive_fade_small"

    const dates = upcomingClass?.slots?.map((item) => {
        const momentDateTime = moment.tz(
            `${item.class_date} ${item.class_time}`,
            "YYYY-MM-DD HH:mm:ss",
            item.time_zone || DEFAULT_TIMEZONE
        );

        return {
            id: item.id,
            type: upcomingClass?.class_type,
            date: momentDateTime.format("MMM D, YYYY"),
            time: momentDateTime.format("h:mm a"),
            cost: upcomingClass?.instructor_earning,
        };
    });

    const handleAcceptReschedule = () => {
        acceptReschedule({
            bookingSlot_id: upcomingClass.id,
            booking_id: upcomingClass.booking_id,
            status: RESCHEDULE_STATUS.accepted,
        });
    };

    const handleRejectReschedule = () => {
        rejectReschedule({
            bookingSlot_id: upcomingClass.id,
            booking_id: upcomingClass.booking_id,
            status: RESCHEDULE_STATUS.rejected,
        });
    };

    const momentDateTime = moment.tz(
        `${upcomingClass.class_date} ${upcomingClass.class_time}`,
        "YYYY-MM-DD HH:mm:ss",
        upcomingClass.time_zone || DEFAULT_TIMEZONE
    );

    const classDate = {
        type: upcomingClass?.class_type,
        date: momentDateTime.format("MMM D, YYYY"),
        time: momentDateTime.format("h:mm a"),
        cost: upcomingClass.instructor_earning,
    }

    const bookingSlot = upcomingClass?.slots?.[0];

    const dateTimeAfter25Hours = timeLeftToAcceptOrDecline(
        upcomingClass?.reschedule?.created_at,
        upcomingClass?.reschedule?.new_class_date,
        upcomingClass?.reschedule?.new_class_time,
        bookingSlot?.time_zone,
        bookingSlot?.class_date,
        bookingSlot?.class_time,
    );

    return (
        <ClassItem isRescheduled={isRescheduled}>
            <ClassInfo>
                <Avatar onClick={(() => onProfile?.())} profile={upcomingClass?.user_profile_pic}
                        alt={upcomingClass?.user_first_name}/>


                <InfoContainer>
                    <Info>
                        <Name onClick={(() => onProfile?.())}>{upcomingClass?.user_first_name}</Name>
                        <Details>
                            <span>
                                <UserIcon color="placeholder" width="15" height="15"/>
                            </span>
                            <span>{upcomingClass?.student_per_class}</span> |{" "}
                            <span>{upcomingClass?.class}</span>
                        </Details>

                        {isRescheduled && dateTimeAfter25Hours ? <Countdown
                            targetTime={dateTimeAfter25Hours}
                            timezone={bookingSlot?.time_zone || DEFAULT_TIMEZONE}
                        /> : null}

                        {isOnline ?
                            <ZoomLinkContainer>
                                <ClassLinkLabel>{"Class link :"}</ClassLinkLabel>
                                <ZoomLinkLabel href={upcomingClass?.class_link} target="_blank"
                                               rel="noopener noreferrer">{"Zoom Link"}</ZoomLinkLabel>
                            </ZoomLinkContainer> : null}

                    </Info>
                    <div>
                        <ButtonPrimary
                            variant={badgeVariant}
                            style={{
                                pointerEvents: "none",
                            }}
                        >
                            {isOnline ? "Online" : class_type}
                        </ButtonPrimary>
                    </div>
                </InfoContainer>
            </ClassInfo>

            <ExpandedDetails>

                <DetailsBlock>

                    <ClassDateCard
                        date={classDate}
                        priceBreakdown={{
                            booking_total_amount: upcomingClass.booking_total_amount,
                            discount_amount: upcomingClass.discount_amount,
                            teache_fee: upcomingClass.teache_fee,
                            total_amount: upcomingClass.instructor_earning
                        }}
                        isOnline={isOnline}
                    />
                </DetailsBlock>

                {isRescheduled && (
                    <RescheduleCard
                        newDate={moment(upcomingClass.reschedule?.new_class_date).format(
                            "MMM D, YYYY"
                        )}
                        newTime={moment(
                            upcomingClass.reschedule?.new_class_time,
                            "HH:mm"
                        ).format("h:mm a")}
                    />
                )}

                <Actions>
                    {isRescheduled ? (
                        <>
                            <ButtonPrimary onClick={handleAcceptReschedule}>
                                Accept
                            </ButtonPrimary>
                            <ButtonPrimary onClick={handleRejectReschedule} variant="primary_fade">
                                Decline
                            </ButtonPrimary>
                        </>
                    ) : (
                        <>
                            <ButtonPrimary variant="secondary" onClick={sendMessage}>Message</ButtonPrimary>
                            <ButtonPrimary variant="primary_fade" onClick={onCancel}>
                                Cancel
                            </ButtonPrimary>
                        </>
                    )}
                </Actions>
            </ExpandedDetails>
        </ClassItem>
    );
};

const ClassItem = styled.div`
    border-width: 2px;
    border-style: solid;
    border-color: ${(({isRescheduled}) => isRescheduled ? themeColor("blue") : defaultThemeColors.lightBlue)};
    background-color: ${defaultThemeColors.white};
    border-radius: 8px;
    overflow: hidden;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
`;

const ClassInfo = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
`;

const InfoContainer = styled.div`
    display: flex;
    justify-content: space-between;
    flex: 1;
`

const Info = styled.div`
    flex: 1;
    display: grid;
    gap: 0.5rem;
`;

const Name = styled.div`
    font-size: ${fonts.sizes.regular};
    font-weight: bold;

    cursor: pointer;
`;

const Details = styled.div`
    font-size: ${fonts.sizes.small};
    color: ${defaultThemeColors.placeholder};
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.3rem;

    & span:nth-of-type(2) {
        color: ${defaultThemeColors.txt};
    }
`;

const ExpandedDetails = styled.div`
    padding-top: 1rem;
    gap: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
`;

const DetailsBlock = styled.div`
    flex-grow: 1;
`;

const Actions = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.6rem;

    > * {
        grid-column: span 1;
    }

    &:has(> *:nth-child(3)) > :first-child {
        grid-column: span 2;
    }

    > :only-child {
        grid-column: span 2;
    }
`;


const ZoomLinkContainer = styled.p`
    display: flex;
    gap: 0.5rem;
`

const ClassLinkLabel = styled.p`
    color: ${defaultThemeColors.placeholder};
    font-size: ${fonts.sizes.small};
`

const ZoomLinkLabel = styled.a`
    color: ${defaultThemeColors.blue};
    font-size: ${fonts.sizes.small};
    font-weight: 500;
    white-space: nowrap;
    text-transform: capitalize;
    text-decoration: underline;
    cursor: pointer;
`